import React, { useState, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { BiSolidReport } from "react-icons/bi";

const AnualReport = () => {
  const [selectYear, setSelectYear] = useState("");
  const downloadLinkRef = useRef(null);

  const handleYearChange = (event) => {
    setSelectYear(event.target.value);
  };

  // Construir la URL para la descarga del informe
  const url = `${process.env.REACT_APP_REPORT_FULL_EXPORT_EXCEL}Amebo&year=${selectYear}`;

  const handleDownloadClick = () => {
    // Realizar una solicitud GET para verificar si el recurso existe
    axios
      .get(url)
      .then(() => {
        // Si la respuesta es exitosa, activar la descarga a través del enlace oculto
        downloadLinkRef.current.click();
      })
      .catch((error) => {
        // Si hay un error (por ejemplo, 404), mostrar la alerta
        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "Datos no encontrados",
            text: "No hay datos de este año",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No se pudo descargar el archivo.",
          });
        }
      });
  };

  return (
    <div className="boxreportallprov">
      <div className="boxreport">
        <div className="ReportsProv">
          <div className="displayboxReport-prov">
            <div className="iconReportbox-prov">
              <BiSolidReport className="iconreport-prov" />
            </div>
            <div className="widtallreport-amebo">
              <div className="widtallreport-prov">
                <select
                  className="montinputreport-prov"
                  value={selectYear}
                  onChange={handleYearChange}
                >
                  <option value="">Selecciona un año</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                  <option value="2031">2031</option>
                  <option value="2032">2032</option>
                  <option value="2033">2033</option>
                  <option value="2034">2034</option>
                </select>
              </div>

              <div
                className="boxinputbuttonreport-amebo"
                style={{ marginTop: "10px" }}
              >
                <a
                  ref={downloadLinkRef}
                  href={url}
                  download
                  style={{ display: "none" }}
                >
                  Descargar
                </a>
                <button
                  className="buttonreport-amebo"
                  onClick={handleDownloadClick}
                >
                  Descargar Reporte
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnualReport;
